import React from 'react'
import PropTypes from 'prop-types'
import { loadImage } from 'integrations/unsplash'
import { Box, Flex, Container } from '@chakra-ui/react'
import { withTranslation } from 'i18n'
import AvatarPlaceholder from 'static/assets/images/home-page-section-layouts/whos-listening/avatar.png'

const WhosListeningLayoutOne = ({ t, data, meta, theme, brandColor }) => {
  if (!data.length) {
    return false
  }

  const titleNode = () => {
    if (!meta.title) return false

    return (
      <Box
        as='h2'
        color={theme.sectionTitleColor}
        fontFamily='heading'
        fontSize='sectionTitle'
        fontWeight='heading'
        mb={4}
      >
        {meta.title}
      </Box>
    )
  }

  return (
    <Box
      bg={theme.backgroundColor}
      px={[2, 4, 8, 16]}
    >
      <Box bg={theme.backgroundColor} py={8} px={[4, 4, 0, 0]}>
        <Container maxW='container.lg' mx='auto' px={0}>
          {titleNode()}
          <Flex
            flexWrap='wrap'
            flexDirection={{xs: 'column', md: 'row' }}
            mx={-6}
            my={-6}
          >
            {data.map((member, index) => {
              return (
                <Box
                  key={index}
                  px={6}
                  py={6}
                  w={['100%', '50%', '50%', '50%']}
                >
                  <Box
                    boxShadow='site'
                    bg={theme.cardBackgroundColor}
                    display='flex'
                    overflow='hidden'
                    p={4}
                    rounded='site'
                  >
                    <Box display='flex' w='100%'>
                      <Box w='7rem'>
                        <Box
                          boxShadow='site'
                          bg='white'
                          rounded='site'
                          backgroundImage={`url(${loadImage(member.image || AvatarPlaceholder, 400)})`}
                          backgroundPosition={`${member.imgFocalX}% ${member.imgFocalY}%`}
                          backgroundRepeat='no-repeat'
                          backgroundSize='cover'
                          boxSize={24}
                        />
                      </Box>
                      <Box w='calc(100% - 7rem)'>
                        <Box
                          color={theme.textColor}
                          fontFamily='heading'
                          fontWeight='heading'
                          fontSize='heading'
                        >
                          {member.name}
                        </Box>
                        <Box
                          as='p'
                          color={theme.textColor}
                          fontFamily='body'
                          fontWeight='body'
                          fontSize='body'
                          isTruncated
                          mt={2}
                          mb={0}
                        >
                          {member.occupation}
                        </Box>
                        <Box
                          as='p'
                          color={theme.textColor}
                          fontFamily='body'
                          fontWeight='body'
                          fontSize='body'
                          isTruncated
                          my={0}
                        >
                          {member.company}
                        </Box>
                        {member.email && <Box
                          as='p'
                          color={brandColor}
                          fontFamily='body'
                          fontWeight='body'
                          fontSize='body'
                          isTruncated
                          mt={2}
                          mb={0}
                        >
                          <a href={`mailto:${member.email}?subject=${t('editor:editor.emailSubject')}`}>
                            {member.email}
                          </a>
                        </Box>
                        }
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )
            })}
          </Flex>
        </Container>
      </Box>
    </Box>
  )
}

WhosListeningLayoutOne.propTypes = {
  data: PropTypes.array,
  meta: PropTypes.object,
  theme: PropTypes.object,
  t: PropTypes.func.isRequired,
  brandColor: PropTypes.string.isRequired
}

export default withTranslation(['editor'])(WhosListeningLayoutOne)
